import React from "react";
import styled from "styled-components";
import SpecialLifeAtButton from "@common/LifeAtButton/Variants/SpecialLifeAtButton";
import { ToDesktopUtil } from "@desktop/index";
import { BrowserUtil } from "@util/index";

const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    height: 100vh;
    padding: 50px;

    background-color: seashell;
`;

const PageHeader = styled.h1`
    padding: 10px 0;
`;

const PageSubheader = styled.h2`
    padding: 10px 0;
`;

const InstructionStepsList = styled.ol<{ wide: boolean }>`
    width: ${(props) => (props.wide ? "90%" : "60%")};
`;

const InstructionStep = styled.li`
    margin: 10px 0;
`;

const StyledButton = styled(SpecialLifeAtButton)`
    height: 42px;
    width: 300px;
    margin-top: 40px;
    padding: unset;
`;

interface ErrorInstructionStepData {
    readonly id: string;
    readonly msg: string;
    readonly link?: string;
    readonly linkLabel?: string;
}
const ERROR_INSTRUCTIONS_STEPS: ErrorInstructionStepData[] = [
    {
        id: "check-faq",
        msg: "You can check out our FAQ to see if there's anything that might help you solve " + "this in the meantime",
        linkLabel: "FAQ",
        link: "/faq",
    },
    {
        id: "capture-info",
        msg:
            'To help us, please open up your browser console and take a screenshot of the "Console" tab' +
            " to highlight any errors",
        link: "https://balsamiq.com/support/faqs/browserconsole/#:~:text=To%20open%20the%20developer%20console,(on%20Windows%2FLinux).",
        linkLabel: "instructions on how to do this",
    },
    {
        id: "email-us",
        msg:
            "Email us at contact@lifeat.io and we will look into this! Details like your account email, device," +
            " browser, geographic location, etc. and screenshots will help us narrow down the issue. " +
            " This information will only be used internally.",
        linkLabel: "use our email template",
        link: "mailto:contact@lifeat.io?&subject=App%20crash%20support%20request%20",
    },
];

interface ErrorBoundaryProps {
    error: never;
    resetErrorBoundary: never;
}

/**
 * Fallback Component. Params are passed by default.
 * See react-error-boundary package docs for more info.
 * @param error
 * @param resetErrorBoundary
 * @constructor
 */
function GlobalErrorFallback({ error, resetErrorBoundary }: ErrorBoundaryProps) {
    return (
        <PageWrapper>
            <PageHeader>{"Uh-oh! You found an error that we didn't plan for–that's on us!"}</PageHeader>
            <PageSubheader>{"We'd love it if you could help us figure out what happened 👇"}</PageSubheader>

            <InstructionStepsList wide={ToDesktopUtil.isWindowMenubar()}>
                {ERROR_INSTRUCTIONS_STEPS.map((step: ErrorInstructionStepData) => {
                    return (
                        <InstructionStep key={`error-instruction-step-${step.id}`}>
                            <span>{step.msg + " "}</span>
                            {step.link && <a href={step.link}>{`(${step.linkLabel})`}</a>}
                        </InstructionStep>
                    );
                })}
            </InstructionStepsList>

            <StyledButton
                isLink={false}
                handleClick={() => BrowserUtil.reloadPage()}
                text={"Try loading LifeAt again"}
                variant={"blue"}
            />
        </PageWrapper>
    );
}

export default GlobalErrorFallback;
